import { useCallback } from 'react';
import { downloadBlob, useApiCall } from './apiHelpers';

const useDownloadPdf = <TPayload>(endpoint: string, filename: string, fallback: string) => {
  const { authFetch, isReady, run, isLoading, error } = useApiCall();

  const download = useCallback(
    async (payload: TPayload): Promise<boolean> => {
      if (!isReady) return false;
      const outcome = await run<Blob>(
        () => authFetch(endpoint, { method: 'POST', headers: { Accept: 'application/pdf' }, body: JSON.stringify(payload) }),
        fallback,
      );
      if (!outcome.ok) return false;
      downloadBlob(outcome.data, filename);
      return true;
    },
    [authFetch, isReady, run, endpoint, filename, fallback],
  );

  return { download, loading: isLoading, error: error || null };
};

export default useDownloadPdf;
